var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 38,
    fill: "#73151F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.912 62.1833L51.2428 45.2303L49.9235 43.3131L41.5761 31.186L40.8842 30.1812H30.6272L33.1285 33.8163L44.2271 49.9426L45.5464 51.8579L54.4644 64.8151L55.1563 65.819H65.4133L62.9115 62.1838L62.912 62.1833ZM56.3754 63.4987L47.1107 50.0374L45.7915 48.1212L35.0405 32.5014H39.6651L48.3592 45.1336L49.6785 47.0499L61 63.4987H56.3754Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7909 48.1211L47.1102 50.0374L45.5463 51.8574L33.5459 65.8184H30.5867L44.227 49.9425L45.7909 48.1211Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1782 30.1812L51.2422 45.2303L49.6784 47.0499L48.3591 45.1336L49.923 43.3131L58.6859 33.1139L61.219 30.1812H64.1782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.fc65777650d25a9a5de4c2595ede6456.svg";
export { ForwardRef as ReactComponent };